import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postMailTemplateList: (params: MailTemplateListReqDto): Promise<MailTempalteListResDto> =>
    request({
      url: endpoints.mailtemplate.list,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postMailTemplateInfo: (params: MailTemplateSaveReqDto): Promise<MailTempalteInfoResDto> =>
    request({
      url: endpoints.mailtemplate.info,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postMailTemplateAdd: (params: MailTemplateSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.mailtemplate.add,
      method: 'post',
      data: paramsToFormData(params),
    }),
   postMailTemplateSave: (params: MailTemplateSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.mailtemplate.update,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postMailTemplateDelete: (params: MailTemplateSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.mailtemplate.delete,
      method: 'post',
      data: paramsToFormData(params),
    }),        
};
